module.exports = __webpack_public_path__ + "img/olhovazado.1f7b7c1c.svg";